module.exports = __webpack_public_path__ + "img/11.c94495f9.svg";